// extracted by mini-css-extract-plugin
module.exports = {"root":"entity-notice-google-button_root__Xb_r4","primary":"entity-notice-google-button_primary__M8Xdw","secondary":"entity-notice-google-button_secondary__TV8qi"};